module.exports = __webpack_public_path__ + "assets/images/EUR10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EUR10.png
// module id = 1363
// module chunks = 1